module.exports = __webpack_public_path__ + "img/transportaion.0e6d932d.png";